import Store from '../core/Store';
import {
  EventEmitter,
  IEventEmitterListener,
} from '@wix/podcasts-common/dist/pubsub';

import { isServer } from '../environment';
import { IRoutePageWithPathParams } from './types';

interface IRouterConfig {
  baseUrl: string;
  target: '_self' | '_top' | undefined;
}

const DEFAULT_CONFIG = {
  baseUrl: undefined,
  target: undefined,
};

enum RouterEvent {
  ROUTE_CHANGE_STARTED = 'ROUTE_CHANGE_STARTED',
  ROUTE_CHANGE_COMPLETED = 'ROUTE_CHANGE_COMPLETED',
  ROUTE_NOTE_FOUND = 'ROUTE_NOTE_FOUND',
}

interface IRouteChangeStartedData {
  routerState: string;
  route: IRoutePageWithPathParams;
}

interface IRouteChangeCompletedData<T = any> {
  routerState: string;
  route: IRoutePageWithPathParams;
  routeProps: T;
  routeError: any;
}

class Router {
  private _stateStore: Store<string>;
  private _eventEmitter = new EventEmitter();
  private _config: IRouterConfig;

  constructor(config: IRouterConfig = DEFAULT_CONFIG) {
    this._stateStore = new Store<string>(null);
    this.init(config);
  }

  init(config: IRouterConfig = DEFAULT_CONFIG) {
    this._config = config;
  }

  get state() {
    return this._stateStore.get();
  }

  get baseUrl(): string {
    return this._config.baseUrl;
  }

  get target(): string {
    return this._config.target;
  }

  on(event: RouterEvent, fn: IEventEmitterListener) {
    return this._eventEmitter.on(event, fn);
  }

  emit<D = any>(event: RouterEvent, data?: D) {
    this._eventEmitter.emit(event, data);
  }

  pushState(state: string) {
    this._stateStore.set(state);
  }

  subscribeState(fn: Function) {
    if (isServer) {
      throw new Error(
        '`router.subscribeState()` could be called on client side',
      );
    }
    return this._stateStore.subscribe(fn);
  }
}

const router = new Router();

export {
  Router,
  RouterEvent,
  IRouteChangeStartedData,
  IRouteChangeCompletedData,
};
export default router;
